import { render, staticRenderFns } from "./AudioManager.vue?vue&type=template&id=fe521d04&scoped=true"
import script from "./AudioManager.vue?vue&type=script&lang=js"
export * from "./AudioManager.vue?vue&type=script&lang=js"
import style0 from "./AudioManager.vue?vue&type=style&index=0&id=fe521d04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe521d04",
  null
  
)

export default component.exports